'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var GRID_COLUMN_GAP = 16;
var calendarVariantsStyles = {
    primary: styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  "], ["\n  "]))),
    secondary: styled.css(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    margin: 16px;\n\n    .previous-button,\n    .next-button {\n      color: ", ";\n      transition: all .3s;\n\n      &:hover {\n        color: ", ";\n      }\n    }\n\n    .previous-button {\n      order: 2;\n      margin-left: auto;\n    }\n\n    .next-button {\n      order: 3;\n      margin-left: 14px;\n    }\n  "], ["\n    margin: 16px;\n\n    .previous-button,\n    .next-button {\n      color: ", ";\n      transition: all .3s;\n\n      &:hover {\n        color: ", ";\n      }\n    }\n\n    .previous-button {\n      order: 2;\n      margin-left: auto;\n    }\n\n    .next-button {\n      order: 3;\n      margin-left: 14px;\n    }\n  "])), function (_a) {
        var theme = _a.theme;
        return theme.colors.greys.adminGreyDark;
    }, function (_a) {
        var theme = _a.theme;
        return theme.colors.fontColor;
    }),
    flexUi: styled.css(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject([""], [""]))),
};
var daysLayoutVariantsStyles = {
    primary: styled.css(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  "], ["\n  "]))),
    secondary: styled.css(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n    margin: 16px 0 8px;\n    grid-column-gap: ", "px;\n    grid-row-gap: ", "px;\n "], ["\n    margin: 16px 0 8px;\n    grid-column-gap: ", "px;\n    grid-row-gap: ", "px;\n "])), GRID_COLUMN_GAP, GRID_COLUMN_GAP / 2),
    flexUi: styled.css(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject([""], [""]))),
};
var CalendarViewWrapper = styled__default.section(templateObject_7 || (templateObject_7 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  width: ", ";\n  font-family: ", ";\n\n  ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  width: ",
    ";\n  font-family: ", ";\n\n  ", ";\n"])), function (_a) {
    var theme = _a.theme, size = _a.size, variant = _a.variant;
    var isSecondary = variant === 'secondary';
    var cellsWidth = theme.components.calendar.sizes[size].cell.number * theme.components.calendar.daysInRow;
    var gapsWidth = GRID_COLUMN_GAP * 6;
    return (isSecondary ? (cellsWidth + gapsWidth) : cellsWidth) + "px";
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var variant = _a.variant;
    return calendarVariantsStyles[variant];
});
var DaysLayout = styled__default.section(templateObject_8 || (templateObject_8 = tslib_es6.__makeTemplateObject(["\n  display: inline-grid;\n  grid-template-columns: repeat(", ", 1fr);\n\n  ", ";\n"], ["\n  display: inline-grid;\n  grid-template-columns: repeat(", ", 1fr);\n\n  ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.components.calendar.daysInRow;
}, function (_a) {
    var variant = _a.variant;
    return daysLayoutVariantsStyles[variant];
});
var MessageContainer = styled__default.div(templateObject_9 || (templateObject_9 = tslib_es6.__makeTemplateObject(["\n  margin-top: 21px;\n"], ["\n  margin-top: 21px;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;

exports.CalendarViewWrapper = CalendarViewWrapper;
exports.DaysLayout = DaysLayout;
exports.MessageContainer = MessageContainer;
